// extracted by mini-css-extract-plugin
export default {"bodyStyleSection":"kSn5CA_NaCTc8giLBtbK","bodyStyleName":"u0OKl1crxXqyksA6RmD3","name":"Xe9tXhe0LkZOhkfGhLy3"};